import React from "react";

import CollapsiblePanel from "@/components/CollapsiblePanel";
import DataCompareStrength from "@/components/DataCompareStrength";
import NoData from "@/components/NoData";

import { useMatchInfo } from "../ThongTinTranDau/MatchInfoContext";


const CompareStrength = () => {
  const { matchComparison, matchAnalysis } = useMatchInfo();

  return (
    <CollapsiblePanel
      title="So Sánh Sức Mạnh"
    >
      {!matchComparison || !matchAnalysis || matchAnalysis.length === 0 ? (
        <NoData />
      ) : (
        <DataCompareStrength
          match={matchAnalysis}
          comparison={matchComparison}
        />
      )}
    </CollapsiblePanel>
  );
};

export default CompareStrength;
